export const LS_KEYS = {
    IS_TOOLTIP_DISPLAYED: 'isTooltipDisplayed'
};